import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const reconMain = '#37474F';
const reconMenuContrast = '#9E9E9E';
const reconMenuSelected = '#FFF';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: 'rgba(198, 0, 0, 1)',
      contrastText: '#37474F',
    },
    secondary: {
      light: reconMenuSelected,
      main: reconMain,
      contrastText: reconMenuContrast,
    },
    error: {
      main: 'rgba(198, 0, 0, 1)',
      light: 'rgba(198, 0, 0, 0.2)',
    },
  },
  typography: {
    fontFamily: '"Source Sans Pro", sans-serif',
  },
});
export default responsiveFontSizes(theme);
